/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { noticeAdminControllerCreateV1 } from '../fn/notice-admin/notice-admin-controller-create-v-1';
import { NoticeAdminControllerCreateV1$Params } from '../fn/notice-admin/notice-admin-controller-create-v-1';
import { noticeAdminControllerDeleteV1 } from '../fn/notice-admin/notice-admin-controller-delete-v-1';
import { NoticeAdminControllerDeleteV1$Params } from '../fn/notice-admin/notice-admin-controller-delete-v-1';
import { noticeAdminControllerFindByIdV1 } from '../fn/notice-admin/notice-admin-controller-find-by-id-v-1';
import { NoticeAdminControllerFindByIdV1$Params } from '../fn/notice-admin/notice-admin-controller-find-by-id-v-1';
import { noticeAdminControllerReorderV1 } from '../fn/notice-admin/notice-admin-controller-reorder-v-1';
import { NoticeAdminControllerReorderV1$Params } from '../fn/notice-admin/notice-admin-controller-reorder-v-1';
import { noticeAdminControllerSearchV1 } from '../fn/notice-admin/notice-admin-controller-search-v-1';
import { NoticeAdminControllerSearchV1$Params } from '../fn/notice-admin/notice-admin-controller-search-v-1';
import { noticeAdminControllerToggleExposureV1 } from '../fn/notice-admin/notice-admin-controller-toggle-exposure-v-1';
import { NoticeAdminControllerToggleExposureV1$Params } from '../fn/notice-admin/notice-admin-controller-toggle-exposure-v-1';
import { noticeAdminControllerTogglePinnedV1 } from '../fn/notice-admin/notice-admin-controller-toggle-pinned-v-1';
import { NoticeAdminControllerTogglePinnedV1$Params } from '../fn/notice-admin/notice-admin-controller-toggle-pinned-v-1';
import { noticeAdminControllerUpdateV1 } from '../fn/notice-admin/notice-admin-controller-update-v-1';
import { NoticeAdminControllerUpdateV1$Params } from '../fn/notice-admin/notice-admin-controller-update-v-1';
import { NoticeDto } from '../models/notice-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class NoticeAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `noticeAdminControllerSearchV1()` */
  static readonly NoticeAdminControllerSearchV1Path = '/api/v1/notices/admin';

  /**
   * 공지사항 목록 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeAdminControllerSearchV1$Response(params: NoticeAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<NoticeDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = noticeAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 목록 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeAdminControllerSearchV1(params: NoticeAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<NoticeDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.noticeAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<NoticeDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<NoticeDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `noticeAdminControllerCreateV1()` */
  static readonly NoticeAdminControllerCreateV1Path = '/api/v1/notices/admin';

  /**
   * 공지사항 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  noticeAdminControllerCreateV1$Response(params: NoticeAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = noticeAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  noticeAdminControllerCreateV1(params: NoticeAdminControllerCreateV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.noticeAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `noticeAdminControllerFindByIdV1()` */
  static readonly NoticeAdminControllerFindByIdV1Path = '/api/v1/notices/admin/{id}';

  /**
   * 공지사항 상세 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeAdminControllerFindByIdV1$Response(params: NoticeAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
    const obs = noticeAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 상세 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeAdminControllerFindByIdV1(params: NoticeAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<NoticeDto> {
    const resp = this.noticeAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<NoticeDto>): NoticeDto => r.body)
    );
  }

  /** Path part for operation `noticeAdminControllerDeleteV1()` */
  static readonly NoticeAdminControllerDeleteV1Path = '/api/v1/notices/admin/{id}';

  /**
   * 공지사항 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeAdminControllerDeleteV1$Response(params: NoticeAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = noticeAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeAdminControllerDeleteV1(params: NoticeAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.noticeAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `noticeAdminControllerUpdateV1()` */
  static readonly NoticeAdminControllerUpdateV1Path = '/api/v1/notices/admin/{id}';

  /**
   * 공지사항 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  noticeAdminControllerUpdateV1$Response(params: NoticeAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = noticeAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  noticeAdminControllerUpdateV1(params: NoticeAdminControllerUpdateV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.noticeAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `noticeAdminControllerReorderV1()` */
  static readonly NoticeAdminControllerReorderV1Path = '/api/v1/notices/admin/reorder';

  /**
   * 공지사항 순서 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeAdminControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  noticeAdminControllerReorderV1$Response(params: NoticeAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = noticeAdminControllerReorderV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 순서 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeAdminControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  noticeAdminControllerReorderV1(params: NoticeAdminControllerReorderV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.noticeAdminControllerReorderV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `noticeAdminControllerToggleExposureV1()` */
  static readonly NoticeAdminControllerToggleExposureV1Path = '/api/v1/notices/admin/{id}/toggle-exposure';

  /**
   * 공지사항 노출/비노출 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeAdminControllerToggleExposureV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeAdminControllerToggleExposureV1$Response(params: NoticeAdminControllerToggleExposureV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = noticeAdminControllerToggleExposureV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 노출/비노출 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeAdminControllerToggleExposureV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeAdminControllerToggleExposureV1(params: NoticeAdminControllerToggleExposureV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.noticeAdminControllerToggleExposureV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `noticeAdminControllerTogglePinnedV1()` */
  static readonly NoticeAdminControllerTogglePinnedV1Path = '/api/v1/notices/admin/{id}/toggle-pinned';

  /**
   * 공지사항 고정/비고정 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeAdminControllerTogglePinnedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeAdminControllerTogglePinnedV1$Response(params: NoticeAdminControllerTogglePinnedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = noticeAdminControllerTogglePinnedV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 고정/비고정 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeAdminControllerTogglePinnedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeAdminControllerTogglePinnedV1(params: NoticeAdminControllerTogglePinnedV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.noticeAdminControllerTogglePinnedV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
